// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25thw","col":"styles_col__1sDp1"};